import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
interface CTAButtonProps {
  productName?: string;
  regularPrice?: string;
  salePrice?: string;
  discount?: string;
  url?: string;
  trackingName?: string;
}
const CTAButton: React.FC<CTAButtonProps> = ({
  productName = 'BareEarth Grounding Sheets',
  regularPrice = '$219.98',
  salePrice = '$109.99',
  discount = '50% OFF',
  url = 'https://offer.bareearthlife.com/groundedsheets/v719/checkout-med?uid=4027&oid=858&affid=719',
  trackingName = 'BareEarth Grounding Sheets'
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Facebook Pixel tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Advertorial_ClickToOffer', {
            content_name: trackingName,
            content_category: 'Health',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Facebook Pixel tracking error:', error);
      }
    }, 0);
    // Google Tag Manager tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).gtag) {
          ;
          (window as any).gtag('event', 'conversion', {
            send_to: 'AW-17548177287/xQtBCOLL2LsbEIffz69B',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Google Tag Manager tracking error:', error);
      }
    }, 0);
  };
  return <div className="w-full max-w-md mx-auto border border-gray-300 rounded-lg p-4 bg-white" data-id="element-16907" data-mp="210cb5eid5p03">
      <div className="flex items-center gap-1.5 mb-2" data-id="element-16908" data-mp="25yw2xvjn1v0d">
        <TagIcon className="h-3.5 w-3.5 text-gray-600" data-id="element-16909" data-mp="25ydwk639i0eq" />
        <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-16910" data-mp="2ays3fkt4n4b6">
          READER ACCESS
        </span>
      </div>

      <h3 className="text-base font-serif font-medium text-gray-900 mb-1.5" data-id="element-16911" data-mp="2fxuyqdjb1w5y">
        {productName}
      </h3>

      <div className="flex items-center gap-1.5 mb-3" data-id="element-16912" data-mp="1q9h73qcvbei1">
        <span className="text-sm text-gray-400 line-through" data-id="element-16913" data-mp="1law7nt5fwyun">
          {regularPrice}
        </span>
        <span className="text-base font-medium text-green-600" data-id="element-16914" data-mp="1zz92unwpedo3">
          {salePrice}
        </span>
        <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded" data-id="element-16915" data-mp="1v80xq42epegq">
          {discount}
        </span>
      </div>

      <a href={url} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="block w-full bg-gray-900 hover:bg-gray-800 text-white font-medium text-base py-3 px-6 rounded transition-colors duration-200 text-center" data-id="element-16916" data-mp="291s4x5so0m9a">
        <span className="flex items-center justify-center gap-2" data-id="element-16917" data-mp="2dzjwtztb88dh">
          Access Offer
          <ArrowRightIcon className="h-4 w-4" data-id="element-16918" data-mp="okdrpbx9muca" />
        </span>
      </a>
    </div>;
};
export default CTAButton;